// Costanti e helper condivisi del configuratore tecnico
import { Sun, Zap, Battery } from 'lucide-react';

// Costanti di animazione framer-motion (estratte per performance)
export const FADE_IN_ANIMATION = {
  initial: { opacity: 0, y: 10 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, scale: 0.95 },
  transition: { duration: 0.2 }
};

export const EXPAND_ANIMATION = {
  initial: { height: 0, opacity: 0 },
  animate: { height: 'auto', opacity: 1 },
  exit: { height: 0, opacity: 0 },
  transition: { duration: 0.2 }
};

export const INVERTER_TYPE_CODES = ['INVERTER', 'INVERTER_IBRIDO'];

export const TYPE_ICONS = {
  MODULI: Sun,
  INVERTER: Zap,
  INVERTER_IBRIDO: Zap,
  STORAGE: Battery,
};

export const TYPE_COLORS = {
  MODULI: { bg: 'bg-amber-50', border: 'border-amber-200', icon: 'text-amber-500' },
  INVERTER: { bg: 'bg-blue-50', border: 'border-blue-200', icon: 'text-blue-500' },
  INVERTER_IBRIDO: { bg: 'bg-indigo-50', border: 'border-indigo-200', icon: 'text-indigo-500' },
  STORAGE: { bg: 'bg-emerald-50', border: 'border-emerald-200', icon: 'text-emerald-500' },
};

// Valutazione rapporto DC/AC
export const evaluateDcAcRatio = (ratio) => {
  const r = parseFloat(ratio);
  if (isNaN(r) || r === 0) return { status: 'neutral', message: 'Non calcolabile', color: 'text-zinc-400' };
  if (r >= 0.8 && r <= 1.3) return { status: 'ok', message: 'Ottimale', color: 'text-emerald-600' };
  if (r > 1.3 && r <= 1.5) return { status: 'warning', message: 'Accettabile', color: 'text-amber-600' };
  if (r < 0.7) return { status: 'error', message: 'Troppo basso', color: 'text-rose-600' };
  return { status: 'error', message: 'Troppo alto', color: 'text-rose-600' };
};

// Specifica tecnica chiave per tipologia articolo
export const getKeySpec = (item) => {
  if (!item) return null;
  if (item.type_code === 'MODULI' && item.technical_specs?.pmax_w) {
    return `${item.technical_specs.pmax_w}W`;
  }
  if ((item.type_code === 'INVERTER' || item.type_code === 'INVERTER_IBRIDO') && item.technical_specs?.potenza_nominale_ac_kw) {
    return `${item.technical_specs.potenza_nominale_ac_kw}kW`;
  }
  if (item.type_code === 'STORAGE' && item.technical_specs?.capacita_nominale_kwh) {
    return `${item.technical_specs.capacita_nominale_kwh}kWh`;
  }
  return null;
};
